import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { layoutAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';

import { loadById } from 'modules/Common/reducers/morenews';
import { loadMediaForArticles } from 'modules/Common/reducers/media';
import MoreNewsList from 'modules/News/components/MoreNewsList';
import {canonicalLink} from 'utils/seoUtils';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';


const INITIAL_PAGE_SIZE = 12;

@layoutAsyncConnect(
  'MoreNews',
  [{
    dispatch: ({params: {basketId}}) => loadById(basketId, INITIAL_PAGE_SIZE + 1),
    state: (state, {params: {basketId} = {}} = {}) => ({ basket: state.common.morenews[basketId] }),
    then: ({dispatch, state, result: {articles}}) => loadMediaForArticles(state, dispatch, articles)
  }]
)
@catchLifeCycleErrors
export default class CustomBasketNews extends Component {
  static propTypes = {
    basket: PropTypes.object,
    params: PropTypes.object,
    routes: PropTypes.array
  };

  render() {
    const {
      basket: {
        title = "News",
        name: basketName
      } = {},
      params: {
        basketId
      } = {},
      routes
    } = this.props;

    return <div>
      <MetaDataWrapper helmetProps={{...canonicalLink(routes, {basketId, basketName})}}/>
      <h1 className="page-main-title">{title}</h1>
      <MoreNewsList
        title = {title}
        basketQuery={{key: "basketId", value: basketId}}
        initialPageSize={INITIAL_PAGE_SIZE}
      />
    </div>;
  }
}



// WEBPACK FOOTER //
// ./modules/News/containers/CustomBasketNews.js